/**
 * Firebase Configuration for Web Push Notifications
 * 
 * Initializes Firebase app and exports the messaging instance.
 * Uses environment variables from .env for configuration.
 */

import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DB_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MSG_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase app
const firebaseApp = initializeApp(firebaseConfig);

/**
 * Get Firebase Messaging instance (async - checks browser support first).
 * Returns null if the browser does not support Firebase Messaging.
 */
let messagingInstance = null;

export const getFirebaseMessaging = async () => {
  if (messagingInstance) return messagingInstance;

  try {
    // Service workers (required for FCM) only work on HTTPS or localhost
    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    if (window.location.protocol !== 'https:' && !isLocalhost) {
      console.info('FCM web push requires HTTPS. Push notifications are disabled on this origin.');
      return null;
    }

    const supported = await isSupported();
    if (supported) {
      messagingInstance = getMessaging(firebaseApp);
      return messagingInstance;
    }
    console.info('Firebase Messaging is not supported in this browser.');
    return null;
  } catch (error) {
    console.error('Error initializing Firebase Messaging:', error);
    return null;
  }
};

export default firebaseApp;
